import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Question, Questionnaire } from '@app/core/models/questionnaire.model';

@Component({
  selector: 'app-slider',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './slider.html',
  styleUrl: './slider.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Slider),
      multi: true
    }
  ]
})
export class Slider implements OnInit {
  @Input() questionnaire: Questionnaire | null = null;
  @Input() question: Question | null = null;
  @Input() questionNumber: number = 0;
  @Input() isInvalid: boolean = false;
  @Input() errorMessage: string = '';
  @Input() formControl?: FormControl;

  @Output() answerChange = new EventEmitter<any>();

  value: number = 0;
  min: number = 0;
  max: number = 10;
  disabled = false;

  onChange = (value: number) => {};
  onTouched = () => {};

  ngOnInit() {
    if (this.question?.questionSpecificOptions) {
      const options = this.question.questionSpecificOptions;
      this.min = Number(options.minValue) || 0;
      this.max = Number(options.scalePoints) || 10;
      this.value = this.min;
    }

    if (this.formControl) {
      this.formControl.valueChanges.subscribe(value => {
        this.value = value !== undefined && value !== null ? value : this.min;
      });
    }
  }

  writeValue(value: number): void {
    this.value = value || 0;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSliderChange(event: any) {
    this.value = Number(event.target.value);
    this.onChange(this.value);
    this.onTouched();

    if (this.question?.questionId) {
      this.answerChange.emit({
        questionId: this.question.questionId,
        score: this.value
      });
    }

    if (this.formControl) {
      this.formControl.setValue(this.value);
      this.formControl.markAsTouched();
    }
  }
}
